import EditPDF from './EditPDF-redux';

export default EditPDF;
